import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge_par challenge_onsite p-100 text_white">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Target Audience</h2>
            <p>
              OnSite Social is primarily aimed at users in the United States
              like individuals looking to expand their social network, and
              professionals seeking networking opportunities in real-time.
              Moreover, social explorers are interested in meeting new people
              and exploring social interactions in their surroundings.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-2 offset-md-1"
          >
            <div className="challenge_img_onsite text-center">
              <StaticImage
                src="../../../images/case-studies/onsite/audience.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={653}
                height={732}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
